import { type GenericMap, type SettingDefinition } from "@client/types";

import definitions from "./pagePopup/definitions.json";
import structure from "./pagePopup/structure.json";

import { addVersion } from "@client/lib/settings";
import { getStructureDefaultValue, type SettingsStructure } from "./structure";

export const getPagePopupSettingsStructure = (): {
  structure: SettingsStructure;
  definitions: GenericMap<SettingDefinition>;
} => ({
  definitions,
  structure
});

export const getDefaultPagePopupSettings = (): GenericMap<any> => {
  const defaultSettings = getStructureDefaultValue("pagePopup", structure, definitions);
  return addVersion(defaultSettings);
};
